var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SuggestionField } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import CountryUtil from '../util/CountryUtil';
import { injectStores } from '../util/StoresUtil';
let CountrySuggestionField = class CountrySuggestionField extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onCountryChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (searchTerm) => {
                this.setState({ searchTerm });
                this.props.onChange(CountryUtil.getSelectedCountry(searchTerm));
                if (this.state.selectTriggered) {
                    if (this.props.onSelect) {
                        this.props.onSelect();
                    }
                    this.setState({ selectTriggered: false });
                }
            }
        });
        Object.defineProperty(this, "onBlur", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.props.onBlur) {
                    this.props.onBlur();
                }
            }
        });
        Object.defineProperty(this, "onFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.props.onFocus) {
                    this.props.onFocus();
                }
            }
        });
        Object.defineProperty(this, "onSelect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ selectTriggered: true });
            }
        });
        this.state = {
            searchTerm: this.props.country ? this.props.country.name : '',
            selectTriggered: true
        };
    }
    render() {
        const { translate } = this.translateStore;
        return (React.createElement(SuggestionField, { id: this.props.id, label: translate(this.props.labelKey), onBlur: this.onBlur, onChange: this.onCountryChange, onFocus: this.onFocus, items: CountryUtil.mapCountriesForSuggestionField(this.state.searchTerm), value: this.state.searchTerm, onSelect: this.onSelect, onKeyDown: this.onSelect, isInvalid: this.props.isInvalid }));
    }
};
CountrySuggestionField = __decorate([
    injectStores,
    observer
], CountrySuggestionField);
export default CountrySuggestionField;
